var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ugo-form-field"},[(_vm.as_view)?_c('FormViewItem',{attrs:{"label":_vm.label,"required":_vm.required,"hide-label":_vm.hideLabel}},[_vm._t("view")],2):_c('FormItem',{class:_vm.formItemClass,attrs:{"label":_vm.label,"required":_vm.required,"prop":_vm.prop}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }